module.exports = __webpack_public_path__ + "static/teck_2-f2b44cca2c75e43e93e657830aa978bb.jpg";